/**
 * Helper class to track idle time
 * in order to stop tracking
 * user analytics
 */
class IdleTime {
    constructor(options = {}) {
        const noop = () => {}

        this.callback = options.callback || noop
        this.activeCallback = options.activeCallback || noop
        this.idleTime = options.idleTime || 60000
        this.isActive = true

        this.addOrRemoveEvents('addEventListener')
        this.activate()
    }

    activate = () => {
        if (!this.isActive) {
            this.isActive = true
            this.activeCallback()
        }

        clearTimeout(this.timer)
        this.timer = setTimeout(this.idle, this.idleTime)
    }

    idle = () => {
        if (!this.isActive) return

        this.isActive = false
        this.callback()
    }

    destroy = () => {
        clearTimeout(this.timer)
        this.addOrRemoveEvents('removeEventListener')
    }

    addOrRemoveEvents = addOrRemove => {
        window[addOrRemove]('load', this.activate)
        document[addOrRemove]('mousemove', this.activate)
        document[addOrRemove]('scroll', this.activate)
        document[addOrRemove]('keypress', this.activate)
    }
}

export default IdleTime
